import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";
import { API_ROUTES } from "../config";
import { ExportProject, GetProjectsParams } from "../../types/project";

export const getProjects = async (
  params?: GetProjectsParams
): Promise<ExportProject[]> => {
  const res = await axiosClient.get<ApiResponse<ExportProject[]>>(
    API_ROUTES.PROJECTS,
    { params }
  );
  return res?.data?.data ?? [];
};
